import {api} from "./api";
import {slideshow} from "./sliders";

export const loadMore = (path) => {
    const loader = document.getElementById('loading')
    const pageContainer = document.getElementById('load_more')
    const page = pageContainer.dataset.page
    const lastPage = pageContainer.dataset.last
    const current_url = pageContainer.dataset.url
    loader.classList.remove('hidden')
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.delete('search')
    urlSearchParams.delete('route')
    let filters = `limit=15&${urlSearchParams}`
    if (urlSearchParams.get('limit')) {
        filters = urlSearchParams
    }
    
    api.get(`${path}&page=${page}&${filters}&url=${current_url}`)
        .then(async (response) => {
            const text = await response.text();
            let article = document.getElementsByTagName('article')
            setTimeout(() => {
                article[0].insertAdjacentHTML('beforeend', text)
                loader.classList.add('hidden')
                slideshow()
            }, 300)
            if (parseFloat(page) < parseFloat(lastPage)) {
                const nextPage = (parseFloat(page) + 1).toString();
                return pageContainer.setAttribute('data-page', nextPage)
            }
            return pageContainer.remove()
        })
}